module.exports = "<div #el>\n\t<select #select id=\"elem\" class=\"m_selectpicker form-control\" [attr.data-live-search]=\"live\" [attr.data-none-results-text]=\"texts.notFound\"\n    [attr.data-none-selected-text]=\"texts.none\"\n    >\n    </select>\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/cmedina/Code/motto_frontend/src/app/shared/live-search-select/live-search-select.html
// module id = ../../../../../src/app/shared/live-search-select/live-search-select.html
// module chunks = main